'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var reactFontawesome = require('@fortawesome/react-fontawesome');
require('@babel/runtime/helpers/defineProperty');
require('query-string');
var reactRouterDom = require('react-router-dom');
var medipassIcon = require('@medipass/assets/images/medipass-icon.svg');
var medipassByTyroLogo = require('@medipass/assets/images/medipass-tyro-light-logo.png');
var Layout_components_UserMenu = require('./components/UserMenu.js');
var clsx = require('clsx');
var faChevronLeft = require('@fortawesome/pro-solid-svg-icons/faChevronLeft');
var faChevronRight = require('@fortawesome/pro-solid-svg-icons/faChevronRight');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('@fortawesome/pro-solid-svg-icons/faComments');
require('@fortawesome/pro-solid-svg-icons/faBook');
require('@fortawesome/pro-solid-svg-icons/faSignOutAlt');
require('@fortawesome/pro-solid-svg-icons/faUser');
require('@fortawesome/pro-solid-svg-icons/faCaretDown');
require('@fortawesome/pro-solid-svg-icons/faQuestionCircle');
require('@medipass/utils/intercom');
require('@medipass/web-sdk');
require('../state.js');
require('constate');
require('../contexts/DataTableContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var medipassIcon__default = /*#__PURE__*/_interopDefaultLegacy(medipassIcon);
var medipassByTyroLogo__default = /*#__PURE__*/_interopDefaultLegacy(medipassByTyroLogo);

var _templateObject;
var MobileUserMenu = bumbag.styled(Layout_components_UserMenu["default"])(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  margin-bottom: 4rem;\n  @media screen and (min-width: ", "px) {\n    margin-bottom: 0px;\n    display: none;\n  }\n"])), function (props) {
  return bumbag.theme('breakpoints.tablet')(props) + 1;
});

function Sidebar(_ref) {
  var _page$sidebar;

  var _ref$addonComponentBe = _ref.addonComponentBefore,
      addonComponentBefore = _ref$addonComponentBe === void 0 ? null : _ref$addonComponentBe,
      _ref$addonComponentAf = _ref.addonComponentAfter,
      addonComponentAfter = _ref$addonComponentAf === void 0 ? null : _ref$addonComponentAf,
      children = _ref.children,
      userMenuProps = _ref.userMenuProps;
  var page = bumbag.usePage();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "bg-secondary-dark flex min-h-screen flex-col"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: clsx.clsx('flex h-[3.75rem] items-center px-2 ', {
      'justify-center': page == null ? void 0 : page.sidebar.isMinimized
    })
  }, page && page.isCollapsed && /*#__PURE__*/React__default["default"].createElement(bumbag.Button, {
    onClick: page.sidebar.close,
    variant: "link",
    color: "white",
    textDecoration: "none"
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faChevronLeft.faChevronLeft
  })), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Link, {
    to: "/"
  }, page && page.sidebar.isMinimized ? /*#__PURE__*/React__default["default"].createElement(bumbag.Image, {
    src: medipassIcon__default["default"],
    height: "24px",
    alt: "Medipass logo"
  }) : /*#__PURE__*/React__default["default"].createElement(bumbag.Image, {
    src: medipassByTyroLogo__default["default"],
    height: "2.5rem",
    marginLeft: "major-2",
    alt: "Medipass logo"
  }))), addonComponentBefore, /*#__PURE__*/React__default["default"].createElement(bumbag.Navigation, null, /*#__PURE__*/React__default["default"].createElement(bumbag.List, null, children)), addonComponentAfter, /*#__PURE__*/React__default["default"].createElement(MobileUserMenu, _extends__default["default"]({
    isHorizontal: false
  }, userMenuProps)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "grow"
  }), page && !page.isCollapsed && /*#__PURE__*/React__default["default"].createElement("button", {
    "aria-label": page != null && (_page$sidebar = page.sidebar) != null && _page$sidebar.isMinimized ? 'Maximize sidebar' : 'Minimize sidebar',
    className: "bg-secondary-darker flex h-12 w-full items-center justify-end px-4 text-white hover:bg-black focus:bg-black focus:outline-none",
    onClick: page.sidebar.isMinimized ? page.sidebar.maximize : page.sidebar.minimize,
    type: "button"
  }, page.sidebar.isMinimized ? /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faChevronRight.faChevronRight
  }) : /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faChevronLeft.faChevronLeft
  })));
}

Sidebar.defaultProps = {
  addonComponentBefore: undefined,
  addonComponentAfter: undefined
};

exports["default"] = Sidebar;
